// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../work/modules/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".point[data-v-705a3220]{background:linear-gradient(180deg,hsla(0,0%,49%,.24),hsla(0,0%,73%,.16))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
